// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1n80R","col":"styles_col__1bV5y"};